// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MAX_DWEB_WIDTH } from 'shared/styles/base';

export const FooterContainer = styled.div`
  width: 100%;
  max-width: ${MAX_DWEB_WIDTH}px;
  margin: ${({ theme }) => `${theme.spacing.spacing160} auto`};
  word-break: break-word;

  & h1 {
    margin: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleLarge};
  }

  & h2 {
    margin: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleMedium};
  }

  & h3 {
    margin: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleSmall};
  }

  & p {
    margin-top: ${({ theme }) => theme.spacing.spacing50};
    ${({ theme }) => theme.typography.bodyMedium};
  }

  & a {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;
